{
  "navigation.title": "What's new across Atlassian",
  "app.updates.title": "What's new across Atlassian",
  "app.updates.subtitle": "Discover new cloud features designed to unleash your team's potential and see how our latest updates can power your work today.",
  "app.updates.browserTabTitle": "Release Notes | Atlassian Community",
  "appUpdatesDetails.backAction": "Back to release notes",
  "appUpdatesDetails.browserTabTitleSuffix": "Release Notes | Atlassian Community",
  "appUpdatesDetails.notFound": "This release note could not be found. Use the back button to return to release notes.",
  "appUpdatesDetails.error": "Unable to load this release note. Use the back button to return and try again.",
  "appUpdatesDetails.loading": "Loading release note\u2026",
  "appUpdatesDetails.summary": "Summary",
  "appUpdatesDetails.keyChanges": "Key changes",
  "appUpdatesDetails.benefits": "Benefits",
  "appUpdatesDetails.reasonForChange": "Reason for the change",
  "appUpdatesDetails.prepareForChange": "How to prepare for the change",
  "appUpdatesDetails.getStarted": "Getting started",
  "appUpdatesDetails.changelog.release": "Release",
  "appUpdatesDetails.changelog.scheduledStatus": "Scheduled",
  "appUpdatesDetails.changelog.rollingOutStatus": "Rolling Out",
  "appUpdatesDetails.changelog.completedStatus": "Completed",
  "appUpdatesDetails.sidebar.appsImpactedTitle": "Apps impacted",
  "appUpdatesDetails.sidebar.impactRatingTitle": "Change impact",
  "appUpdatesDetails.sidebar.changeTypeTitle": "Contextual tags",
  "appUpdatesDetails.sidebar.impactHigh": "High",
  "appUpdatesDetails.sidebar.impactMedium": "Medium",
  "appUpdatesDetails.sidebar.impactLow": "Low",
  "appUpdates.filters.impactRating.label": "Impact rating",
  "appUpdates.filters.impactRating.high": "High",
  "appUpdates.filters.impactRating.medium": "Medium",
  "appUpdates.filters.impactRating.low": "Low",
  "appUpdates.filters.tags.label": "Contextual tags",
  "appUpdatesTable.column.impactRating": "Impact",
  "appUpdatesTable.column.changeType": "Change type",
  "appUpdatesTable.column.contextualTags": "Contextual tags",
  "appUpdatesTable.impactRating.high": "High",
  "appUpdatesTable.impactRating.medium": "Medium",
  "appUpdatesTable.impactRating.low": "Low",
  "appUpdatesDetails.changelog.changeType": "Change type",
  "appUpdatesDetails.changelog.changeImpact": "Change impact",
  "appUpdatesDetails.changelog.contextualTags": "Contextual tags",
  "appUpdates.aiDisclaimer.beta": "Beta",
  "appUpdates.aiDisclaimer.tooltipText": "Uses AI. Verify results.",
  "appUpdatesDetails.changelog.rolloutSchedule": "Rollout schedule",
  "appUpdatesDetails.changelog.status": "Status",
  "appUpdatesTable.adminCallout.text": "For rollout schedules specific to your organization, visit <appUpdatesLink>App updates</appUpdatesLink> in <adminLink>Atlassian Administration</adminLink>. Organization admin access required."
}
